import { FC } from 'react';

import { Button } from '@eluve/components';

export interface ButtonRendererProps {
  text: string;
  variant?: 'brand' | 'default';
  size?: 's' | 'm' | 'l';
  disabled?: boolean;
  loading?: boolean;
  wFull?: boolean;
}

const SIZE_MAP = { s: 'sm', m: 'md', l: 'lg' } as const;

export const ButtonRenderer: FC<
  ButtonRendererProps & { onPress?: () => void }
> = ({
  text,
  variant = 'brand',
  size = 'l',
  disabled,
  loading,
  wFull,
  onPress,
}) => (
  <Button
    variant={variant}
    size={SIZE_MAP[size]}
    disabled={disabled}
    loading={loading}
    fullWidth={wFull}
    onClick={onPress}
  >
    {text}
  </Button>
);
